import { UPDATE_ADD_PT_DY_FORM } from './constants';
import { DFormEntity } from './fetchDoctorGenieByOID';
import fetchWithRefresh from './fetchWithRefresh';

export type Res = {
    success: boolean;
    draftId?: string;
    error?: string;
};

export default (data: DFormEntity[]): Promise<Res> => {
    const body = {
        fields: data,
    };
    return fetchWithRefresh(UPDATE_ADD_PT_DY_FORM, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('failed to update dy forms');
        }
    });
};
